module.exports = "query PartnerLogs ($limit: Int!, $page: Int!, $id: String!) {\n  logs (limit: $limit, page: $page, id: $id) {\n    total\n    per_page\n    current_page\n    from\n    to\n\n    data {\n      msg\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/PartnerLogs.graphql
// module id = jup8
// module chunks = 1624